import { render, staticRenderFns } from "./MisConversaciones.vue?vue&type=template&id=935c50a8&scoped=true"
import script from "./MisConversaciones.vue?vue&type=script&lang=js"
export * from "./MisConversaciones.vue?vue&type=script&lang=js"
import style0 from "./MisConversaciones.vue?vue&type=style&index=0&id=935c50a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935c50a8",
  null
  
)

export default component.exports